// # -------------------------- MAROC ---------------------------- #
// export const COUNTRY="MAROC"
// export const ADRESSE_EXAMPLE = "Ex : 7 rue bab al mandeb, Casablanca"
// export const PLACES_AUTOCOMPLETE_COUNTRY = "MA"
// export const MAP_DEFAULT_CENTER = [-10.032496504519117, 28.570403281743076]
// export const MAPBOX_STYLE_CDP = ""
// export const MAPBOX_STYLE_ANNONCEDISPLAYCOMPONENT = "mapbox://styles/badrbelkeziz/ckk6r9vo20yzr17qbv2mf76b4"
// export const MAPBOX_STYLE_STEPPER_ESTIMATION_MAP = "mapbox://styles/badrbelkeziz/ckk6r9vo20yzr17qbv2mf76b4"
// export const MAPBOX_STYLE_MAPANNONCES_IMMONEUF = "mapbox://styles/badrbelkeziz/cl08bb11i000414pgdj0tq7hi"
// export const MAPBOX_MAX_BOUNDS = [
//     [-19.212837630624946, 18.17622676835104],
//     [1.5541004873611497, 36.63884752910617],
//   ]

export const COUNTRY_CONFIG = {
  MAROC: {
    COUNTRY: "MAROC",
    ADRESSE_EXAMPLE: "LPexamplePlaceholder",
    PLACES_AUTOCOMPLETE_COUNTRY: "MA",
    // "MAP_DEFAULT_CENTER": [9.516298494688762, 34.45938265142073],
    MAP_DEFAULT_CENTER: [-10.032496504519117, 28.570403281743076],
    // "MAPBOX_STYLE_CDP": "mapbox://styles/badrbelkeziz/ckyq6oq9drhed14run9br24fn",
    // MAPBOX_STYLE_CDP: "mapbox://styles/badrbelkeziz/cl8lf63g4000z14o6lqzjqhs9",
    MAPBOX_STYLE_CDP: "mapbox://styles/badrbelkeziz/clofeqj8w004c01qrcxgb27yi",


    MAPBOX_STYLE_ANNONCE:
      "mapbox://styles/badrbelkeziz/cl6rvgroj000315npg8akcrm4",
    // "MAPBOX_STYLE_ANNONCE": "mapbox://styles/badrbelkeziz/ckk6r9vo20yzr17qbv2mf76b4",
    MAPBOX_STYLE_STEPPER_ESTIMATION_MAP:
      "mapbox://styles/badrbelkeziz/ckyn8fqm453j014l2rfez2ca8",
    MAPBOX_STYLE_MAPANNONCES_IMMONEUF:
      "mapbox://styles/badrbelkeziz/cl08bb11i000414pgdj0tq7hi",
    MAPBOX_MAX_BOUNDS: [
      [-19.212837630624946, 18.17622676835104],
      [1.5541004873611497, 36.63884752910617],
    ],
    CURRENCY: "MAD",
  },
  TUNISIE: {
    COUNTRY: "TUNISIE",
    ADRESSE_EXAMPLE: "Ex : 18 Rue des Orangers, Tunis",
    PLACES_AUTOCOMPLETE_COUNTRY: "TN",
    MAP_DEFAULT_CENTER: [9.516298494688762, 34.45938265142073],
    MAPBOX_STYLE_CDP: "mapbox://styles/badrbelkeziz/cl6gnfug0000c14qpollzh088",
    MAPBOX_STYLE_ANNONCE:
      "mapbox://styles/badrbelkeziz/cl5xtgs8c000x14li2lpvvs6p",
    MAPBOX_STYLE_STEPPER_ESTIMATION_MAP:
      "mapbox://styles/badrbelkeziz/cl52c02th002715n0qgkibh95",
    MAPBOX_STYLE_MAPANNONCES_IMMONEUF:
      "mapbox://styles/badrbelkeziz/cl08bb11i000414pgdj0tq7hi",
    MAPBOX_MAX_BOUNDS: [
      [5.90976536535401, 28.837269448887962],
      [14.3092401242363, 38.58763555739748],
    ],
    CURRENCY: "TND",
  },
};

// # -------------------------- TUNISIE ---------------------------- #
// export const COUNTRY="TUNISIE"
// export const  ADRESSE_EXAMPLE = "Ex : 18 Rue des Orangers, Tunis"
// export const PLACES_AUTOCOMPLETE_COUNTRY = "TN"
// export const MAP_DEFAULT_CENTER = [9.516298494688762,34.45938265142073]
// export const MAPBOX_STYLE_CDP = ""
// export const MAPBOX_STYLE_ANNONCEDISPLAYCOMPONENT = "mapbox://styles/badrbelkeziz/ckk6r9vo20yzr17qbv2mf76b4"
// export const MAPBOX_STYLE_STEPPER_ESTIMATION_MAP = "mapbox://styles/badrbelkeziz/cl52c02th002715n0qgkibh95"
// export const MAPBOX_STYLE_MAPANNONCES_IMMONEUF = "mapbox://styles/badrbelkeziz/cl08bb11i000414pgdj0tq7hi"
// export const MAPBOX_MAX_BOUNDS = [
//     [5.90976536535401, 28.837269448887962],
//     [14.3092401242363, 38.58763555739748],
//   ]
